<script setup lang="ts">
import { computed, inject, ref, unref } from 'vue';
import RelatieAfwijkendEmailadresField from './RelatieAfwijkendEmailadresField.vue';
import { isReadonlyInjectionKey } from '../keys';

const fieldId = 'financieel-emailadres';
const label = 'Financieel e-mailadres';
const propertyName = 'financieelEmailadres';

const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const tooltip = computed(() =>
  unref(hasReadonlyParent)
    ? 'Dit e-mailadres wordt gebruikt voor alle financiële correspondentie.'
    : 'Vul hier een afwijkend e-mailadres in voor alle financiële correspondentie.',
);
</script>

<template>
  <RelatieAfwijkendEmailadresField
    :field-id="fieldId"
    :label
    :property-name="propertyName"
    :tooltip
  />
</template>
